<div class="m-333">
  @for (example of examples; track example) {
  <div class="mb-24">
    <egret-example-viewer
      [exampleId]="example"
      [path]="componentDirPath"
      [data]="exampleComponents[example]"
    ></egret-example-viewer>
  </div>
  }
</div>
